import SuggestedPostDetail from './SuggestedPostDetailAmbassador';
export default SuggestedPostDetail;
